define('models/validator/_base/basevalidator',["backbone"], function (Backbone) {
    "use strict";

    var BaseValidator = Backbone.Model.extend({

        defaults: {
            value           : undefined,
            validationCode  : undefined
        },

        // This will probably never get used, but it's included just in case.
        validate: function(val) {
            this.set('value', val);
            var code = this.validateHasValue(val);
            this.set('validationCode', code);
            return code;
        },

        // Checks if a value exists and sets the appropriate validation code.
        validateHasValue: function(val) {
            var code;
            if (!val || val.length == 0) {
                code = enums.validationCode.empty;
            } else {
                code = enums.validationCode.ok;
            }
            return code;
        },


        // ––––––––––––––––––––––––
        // Evaluate Validation Code
        // ––––––––––––––––––––––––

        // Returns BOOLEAN
        isValid: function(code) {
            code = code == undefined ? this.get('validationCode') : code;
        	return (code === enums.validationCode.ok);
        },

        // Returns BOOLEAN
        isEmpty: function(code) {
            code = code == undefined ? this.get('validationCode') : code;
            return (code === enums.validationCode.empty);
        },



        // ––––––––––––––––––––––––
        // Little Things
        // ––––––––––––––––––––––––

        getIntValue: function(val) {
            if (val) {
                return parseInt(val);
            } else {
                return parseInt( this.get('value') );
            }
        }
    });

    return BaseValidator;
});
